/*
 * Configuration Variables
 */
const Config = {};

Config.CONVEYANCE = {
	SEA: 'bece1655-6d5c-4b02-b7da-8c885b38b095',
	AIR: '9d7eeabc-ffcc-4384-a315-f22fa729fa03',
	// TODO Update with Proper UUIDs
	ROAD: 'b42a4ee9-1e3a-4997-870a-0e7ba3d59865',
	RAIL: 'e8966119-b1f4-4be7-89d2-e0055a756e9a'
};

Config.TRANSACTION_TYPE = {
	IMPORT: 'IMPORT',
	EXPORT: 'EXPORT'
}

Config.ALLOW_PACKAGING = true;

Config.BASIS_OF_VALUATION = {
	CFR: 'CFR',
	CFR_WITH_UPLIFT: 'CFR_WITH_UPLIFT'
};

Config.DEFAULT_PORT_OF_ENTRY = {
	id: "aeb1bdf5-577f-4dad-9b93-c52faaadeff5",
	port: "Dar es Salaam"
};

Config.INSURERS = [
	{
		insurer_id: "d55890b5-6134-4b69-ba92-fa90a5f89fb1",
		name: "Sanlam General Insurance Limited",
		logo: "sanlam-logo.png",
		contacts: {
			email: "marine@sanlam.co.ke",
			helpline: "+254 719 035 000",
			location: "",
			postal_address: "",
			city: ""
		},
        ga_code: ""
	},
	{
		insurerId: "e9b2477f-89b9-47a2-a69e-3d07878cec52",
		name: "CIC General Insurance Limited",
		logo: "cic-logo.png",
		contacts: {
			email: "marine@cic.co.ke",
			helpline: "0703 099 478/ 0703 099 483/ 0703 099 008",
			location: "CIC Plaza, Mara Rd, Upperhill",
			postal_address: "P.O. Box 44041 - 00100",
			city: "Nairobi, Kenya"
		},
        ga_code: "UA-90774373-1"
	},
	{
		insurerId: "3942af1f-27a7-413a-a65e-f96656340d36",
		name: "UAP Insurance Company Limited",
		logo: "uapmutual-logo.png",
		contacts: {
			email: "marine@uap-oldmutual.com",
			helpline: "",
			location: "",
			postal_address: "",
			city: ""
		},
        ga_code: ""
	}
];

export default Config;


// WEBPACK FOOTER //
// ./src/utils/config.js